import { gql } from '@apollo/client';

export const CREATE_COUPON = gql`
  mutation createCoupon($couponInput: CouponInput) {
    createCoupon(couponInput: $couponInput) {
      id
    }
  }
`;

export const UPDATE_COUPON = gql`
  mutation updateCoupon($couponInput: CouponInput) {
    updateCoupon(couponInput: $couponInput) {
      id
    }
  }
`;

export const SEND_COUPONS_TO_TRADER = gql`
  query sendCouponsToTraderOverEmail($traders: [ID], $couponId: ID) {
    sendCouponsToTraderOverEmail(traders: $traders, couponId: $couponId)
  }
`;

export const TRADER_LIST_QUERY = gql`
  query tradersListWithoutSubscription {
    tradersListWithoutSubscription {
      id
      firstName
      lastName
    }
  }
`;

export const DELETE_COUPON = gql`
  mutation deleteCoupon($couponId: ID!) {
    deleteCoupon(couponId: $couponId)
  }
`;
export const COUPONS_QUERY = gql`
  query coupons(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    coupons(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      coupons {
        id
        code
        discountType
        discountValue
        currency {
          id
          currencyName
        }
        usageLimit
        usageCount
        fromDate
        expiryDate
        status
        createdAt
        createdByUserId
        updatedByUserId
      }
      totalCount
      totalPages
    }
  }
`;

export const TRADER_COUPON_BY_ID_QUERY = gql`
  query traderCouponListByCouponId(
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $couponId: ID!
  ) {
    traderCouponListByCouponId(
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      couponId: $couponId
    ) {
      couponTraders {
        id
        trader {
          id
          firstName
          lastName

          phone
        }
        isCouponApplied
        emailSentDate
      }
      totalPages
      totalCount
    }
  }
`;

export const TRADER_COUPON_LIST_QUERY = gql`
  query traderCouponListByCouponId(
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $couponId: ID!
  ) {
    traderCouponListByCouponId(
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      couponId: $couponId
    ) {
      couponTraders {
        id
        firstName
        lastName
        email
        phone
        status
      }
      totalPages
      totalCount
    }
  }
`;

// export const COUPONS_SUBSCRIPTION = gql`
//   subscription coupons(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     coupons(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       coupon {
//         id
//         code
//         discountType
//         discountValue
//         currency {
//           id
//           currencyName
//         }
//         usageLimit
//         usageCount
//         fromDate
//         expiryDate
//         status
//         createdAt
//         createdByUserId
//         updatedByUserId
//       }
//       totalCount
//       totalPages
//     }
//   }
// `;

export const COUPON_LIST_BY_COUPON_ID = gql`
  query traderCouponList(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    traderCouponList(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      couponTraders {
        id
        trader {
          id
          firstName
          lastName
          phone
          callingCode {
            id
            callingCode
          }
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const GET_TRADERS_WITH_APPLIED_COUPONS = gql`
  query getTradersWithAppliedCouponsgetTradersWithAppliedCoupons(
    $couponId: ID!
  ) {
    getTradersWithAppliedCoupons(couponId: $couponId) {
      id
      firstName
      lastName
      phone
      callingCode {
        id
        callingCode
      }
    }
  }
`;
